import { FC } from "react";
import AppLayout from "./AppLayout";

interface Props {
  pageTitle: string;
  pageDescription: string;
}

export const ErrorPageLayout: FC<Props> = ({
  children,
  pageTitle,
  pageDescription,
}) => {
  return (
    <AppLayout pageTitle={pageTitle} pageDescription={pageDescription}>
      {children}
    </AppLayout>
  );
};
